import { useState, useContext } from "react";
import { Box, TextField, Button, Typography, Paper } from "@mui/material";
import api from "../api/client";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = () => {
    const formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);

    api
      .post("/auth/login", formData)
      .then((res) => {
        const { access_token, user, client } = res.data;

        // Guardamos token en Axios
        api.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;

        // Guardamos en contexto
        login({ ...user, client });

        // Guardamos también en localStorage si querés persistencia
        localStorage.setItem("token", access_token);
        localStorage.setItem("user", JSON.stringify({ ...user, client }));

        navigate("/dashboard");
      })
      .catch(() => alert("Invalid credentials"));
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" mb={2}>
          Login
        </Typography>
        <TextField
          label="Username"
          fullWidth
          margin="normal"
          onChange={(e) => setUsername(e.target.value)}
        />
        <TextField
          label="Password"
          type="password"
          fullWidth
          margin="normal"
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
          onClick={handleLogin}
        >
          Login
        </Button>
      </Paper>
    </Box>
  );
}